import {
  type AlternativeName,
  isMelwaysSiteName,
  type SiteName,
} from '@seek/melways-sites';
import { type JSX, type ReactNode, useMemo } from 'react';

import { MelwaysContext } from '../context.ts';
import { getMelwaysInfo, type MelwaysInformation } from '../melways-info.ts';

type ServerProps = {
  url: string | URL;
  site: SiteName;
  staging?: boolean;
  alternative?: AlternativeName;
};

type MelwaysServerProviderProps = (ServerProps | MelwaysInformation) & {
  children: ReactNode;
};

export function MelwaysServerProvider(
  props: MelwaysInformation & { children: ReactNode },
): JSX.Element;
export function MelwaysServerProvider(
  props: ServerProps & { children: ReactNode },
): JSX.Element;
export function MelwaysServerProvider({
  children,
  ...rest
}: MelwaysServerProviderProps) {
  if (!isMelwaysSiteName(rest.site)) {
    throw new Error('MelwaysServerProvider requires a valid site name.');
  }

  const contextValue = useMemo(() => {
    if ('pathWithoutLanguage' in rest) {
      return rest;
    }
    const { url, site, staging = false, alternative } = rest;

    return getMelwaysInfo({ path: url, site, staging, alternative });
  }, [rest]);

  return (
    <MelwaysContext.Provider value={contextValue}>
      {children}
    </MelwaysContext.Provider>
  );
}
